module.exports = __webpack_public_path__ + "static/scale-model-of-tourism-information-in-toledo-ohio-05a1a9f0d5bf91bd1e2db1fbe035ea30.png";